import path from "path";
import { isProdStage } from "./util/stageUtils";
import KatalLogger from "@amzn/katal-logger";

let defaultPath = "/dev/null";

if (process.env.IS_BUILD !== "true" && process.env.STAGE) {
  defaultPath = "/var/log/application_log_pipe";
}

// Physical API Gateway IDs from the `AsinCentral-KatalLoggerStack-{beta,prod}`
// CloudFormation stacks in accounts 581881012334 (beta, us-west-2) and
// 487853185654 (prod, us-east-1). These are stack-managed and change on
// stack replacement — refresh from `AWS::ApiGateway::RestApi` PhysicalResourceId
// if a redeploy assigns new IDs. Long-term: migrate this feature to
// CloudWatch RUM (see `CloudWatchRumStack` already wired in the CDK) and
// retire the self-hosted KatalLogger pipeline.
// Migration tracked in Asana: https://app.asana.com/1/8442528107068/project/1204007214824883/task/1218761316756696
const prodApiGatewayEndpoint =
  "https://xj60sh7phe.execute-api.us-east-1.amazonaws.com/prod/v1/log";
const betaApiGatewayEndpoint =
  "https://7u8csgsrch.execute-api.us-west-2.amazonaws.com/prod/v1/log";

function getLoggerUrl(): string {
  return isProdStage() ? prodApiGatewayEndpoint : betaApiGatewayEndpoint;
}

interface GenericLoggerInterface {
  info: (str: string) => void;
  debug: (str: string) => void;
  error: (str: string) => void;
}
let logger: GenericLoggerInterface;

function localLogger() {
  logger = {
    info: (str) => console.log(`[INFO] ${str}`),
    debug: (str) => console.log(`[DEBUG] ${str}`),
    error: (str) => console.error(`[ERROR] ${str}`),
  };

  return logger;
}

if (process.env.STAGE === "local") {
  logger = localLogger();
} else {
  const loggerUrl = getLoggerUrl();
  if (loggerUrl) {
    console.log("Remote logger url found, configuring remote logger");
    const katalogger = new KatalLogger({
      url: loggerUrl,
      logToConsole: true,
    });
    logger = katalogger;
  } else {
    console.log("No logger url found, configuring console logger");
    logger = localLogger();
  }
}

export default logger;
